/**
 * QuestionnaireDetails — «Расчёт» body for a questionnaire (TASK-332). Moved
 * out of ServiceManagementPage.tsx (KAN-157 god-component split).
 *
 * A questionnaire service collects typed client parameters WITHOUT computing
 * a price, so its body is a QUESTIONS TABLE (name / type / unit / required)
 * instead of formulas/positions/variants.
 */
import type { Service } from '@/services/api/services';
import { QUESTION_TYPE_LABELS, questionnaireFields } from '@/utils/serviceFormula';
import { CalcEmptyNotice } from './CalcEmptyNotice';

export function QuestionnaireDetails({ service }: { service: Service }): JSX.Element {
  const fields = questionnaireFields(service);

  if (fields.length === 0) {
    return <CalcEmptyNotice testid="questionnaire-empty" message="Нет вопросов опросника" />;
  }

  return (
    <div className="space-y-3">
      <p className="text-sm text-gray-500">
        Опросная услуга — бот собирает параметры, цена не рассчитывается.
      </p>
      <div className="overflow-x-auto" data-testid="questionnaire-fields-table">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="text-left text-gray-500 border-b">
              <th className="py-2 pr-4 font-medium">Вопрос</th>
              <th className="py-2 pr-4 font-medium">Тип</th>
              <th className="py-2 pr-4 font-medium">Ед.</th>
              <th className="py-2 font-medium">Обязательный</th>
            </tr>
          </thead>
          <tbody>
            {fields.map((field, idx) => (
              <tr
                key={idx}
                data-testid="questionnaire-field-row"
                className="border-b last:border-b-0"
              >
                <td className="py-2 pr-4 text-gray-800">
                  {field.name}
                  {field.description && (
                    <div className="text-xs text-gray-500">{field.description}</div>
                  )}
                </td>
                <td className="py-2 pr-4 text-gray-600">
                  {QUESTION_TYPE_LABELS[field.type] || field.type}
                  {field.type === 'enum' && (field.options ?? []).length > 0 && (
                    <div className="text-xs text-gray-500">
                      {(field.options ?? []).join(', ')}
                    </div>
                  )}
                </td>
                <td className="py-2 pr-4 text-gray-600">{field.unit ?? ''}</td>
                <td className="py-2 text-gray-600">{field.required ? 'Да' : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
